import React from 'react';
import { QuestionMarkCircleIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

function Help() {
  const faqs = [
    {
      question: 'How do I earn coins?',
      answer: 'You can earn coins by completing quizzes, maintaining daily streaks, and winning on the spin wheel. Each activity has different reward amounts.'
    },
    {
      question: 'What are daily streaks?',
      answer: 'Daily streaks are earned by completing at least one quiz each day. The longer your streak, the more coins you can earn.'
    },
    {
      question: 'How does the spin wheel work?',
      answer: 'The spin wheel is a game where you can win coins. Each spin costs 10 coins, and you can win various amounts based on where the wheel stops.'
    },
    {
      question: 'Can I reset my progress?',
      answer: 'Currently, there is no way to reset your progress. Your achievements and coins are permanent.'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="p-3 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
            <QuestionMarkCircleIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Help Center
            </h2>
            <p className="text-gray-500 dark:text-gray-400">
              Find answers to common questions
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 dark:bg-dark-700 rounded-xl p-4"
            >
              <h3 className="font-medium text-gray-900 dark:text-white mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Support */}
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Need More Help?
        </h3>
        <div className="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-dark-700 rounded-xl">
          <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
            <ChatBubbleLeftRightIcon className="h-5 w-5 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <p className="text-gray-900 dark:text-white">
              Contact our support team
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              support@quizwiz.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help; 